/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tickets_Api_Errors_Not_Allowed_While_ImpersonatingInputs */

const nl_tickets_api_errors_not_allowed_while_impersonating = /** @type {(inputs: Tickets_Api_Errors_Not_Allowed_While_ImpersonatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit kan niet terwijl je een andere gebruiker bekijkt.`)
};

/**

* @param {Tickets_Api_Errors_Not_Allowed_While_ImpersonatingInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const tickets_api_errors_not_allowed_while_impersonating = /** @type {((inputs?: Tickets_Api_Errors_Not_Allowed_While_ImpersonatingInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tickets_Api_Errors_Not_Allowed_While_ImpersonatingInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_tickets_api_errors_not_allowed_while_impersonating(inputs)
});
export { tickets_api_errors_not_allowed_while_impersonating as "tickets.api_errors.not_allowed_while_impersonating" }